import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import Table from '../../../../../../components/table/Table';


export default class Finance extends Component {
    render() {
        if (this.props.details.length > 0) {
            return (
                <Row>
                    <Col md="12">
                        <Table responsive className="table--bordered hpi" style={this.props.style}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Description</th>
                                    <th>Agreement date</th>
                                    <th>Agreement Number</th>
                                    <th>Contact Number</th>
                                    <th>Finance Company</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.details.map((item, i) => (
                                    <tr>
                                        <td>{i + 1}</td>
                                        <td>{item.description}</td>
                                        <td>{item.agreement_date}</td>
                                        <td>{item.agreement_number}</td>
                                        <td>{item.contact_number}</td>
                                        <td>{item.finance_company}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                    </Col>
                </Row>
            );
        }
        return (<Row><Col md="12"><p>There are no records about any finance agreements</p></Col></Row>);
    }
}

Finance.propTypes = {
    details: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/HPI_components/finance.js